// extracted by mini-css-extract-plugin
module.exports = {"service-container":"dd31006766--service-container--RuJD2"};